import { Observable } from 'rxjs';
import { FormSelectOption } from '../../../form-controls/entities/form-select-option.entity';
import { Comparable } from '../../../helpers/entities/comparable.interface';
import { Trackable } from '../../../helpers/entities/trackable.interface';
import { SortInfo } from '../../generic-overview/components/display-settings-bar/entities/sort-info.entity';

import { ActionGroup } from '../../../elements/components/action-group/entities/action-group.entity';
import { ActionItem } from '../../../elements/components/action-item/entities/action-item.entity';
import { MultiFormSelectOptions } from '../../../form-controls/entities/multi-form-select-options.entity';
import { SortOption } from '../../generic-overview/components/display-settings-bar/entities/sort-option.entity';
import { PaginatedResults } from '../../generic-overview/components/pagination/entities/paginated-results.entity';
import { ColumnDef } from '../../list-view/entities/column-definition.entity';
import { SearchBarMode } from '../../list-view/entities/filter-bar-mode.entity';
import { Panel, SearchState } from './search-page-state.entity';

export interface SearchPageConfig<T extends Comparable & Trackable> {
    id: string;
    title?: string;
    features: Record<SearchPageFeatures | Panel, boolean>;
    sort: {
        default: SortInfo;
        options: SortOption[];
    };
    pageSize: {
        default: number;
        options: number[];
    };
    search: {
        searchBarMode: SearchBarMode;
        fieldSearchOptions?: MultiFormSelectOptions;
        refreshTriggers: Observable<boolean>[];
        getSearchBarActionsFct: () => Observable<ActionItem[]>;
        getSearchPageResultsFct: (searchState: SearchState) => Observable<PaginatedResults<T>>;
        getSelectedItemsFct: (selectedIds: string[], searchState: SearchState) => Observable<T[]>;
        getCustomErrorMsgFct?: (error: Error) => string | undefined;
    };
    list: {
        columns$: Observable<ColumnDef<any, T>[]>;
        columnOptions$: Observable<FormSelectOption[]>;
    };
    actions: {
        getGlobalActionsFct: () => Observable<ActionItem[]>;
        getActionsFct: (items: T[]) => Observable<ActionGroup[]>;
        getBulkActionsFct: (items: T[]) => Observable<ActionItem[]>;
        getBatchActionsFct?: () => Observable<ActionItem[]>;
        onRowClickFct?: (item: T) => void;
        onThumbnailClickedFct?: (item: T) => void;
    };
    translations?: {
        itemsSelectedLabelKey?: string;
        noItemsSelectedLabelKey?: string;
        resultsLabelKey?: string;
        noResultsLabelKey?: string;
    };
}

export enum SearchPageFeatures {
    Selection = 'Selection',
    BatchSelection = 'BatchSelection',
    Sort = 'Sort',
    GridView = 'GridView',
    MapView = 'MapView',
    AutoRefresh = 'AutoRefresh',
    RowClickAction = 'RowClickAction',
    PreviewOnThumbnailClick = 'PreviewOnThumbnailClick'
}
